"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroNetlistConversionMessageType = exports.AllegroParsingMessageType = void 0;
var AllegroParsingMessageType;
(function (AllegroParsingMessageType) {
    AllegroParsingMessageType["UnknownProperty"] = "allegro-unknown-property";
    AllegroParsingMessageType["ParsingWarning"] = "allegro-parsing-warning";
})(AllegroParsingMessageType || (exports.AllegroParsingMessageType = AllegroParsingMessageType = {}));
var AllegroNetlistConversionMessageType;
(function (AllegroNetlistConversionMessageType) {
    AllegroNetlistConversionMessageType["DuplicateNet"] = "allegro-netlist-conversion-duplicate-net";
})(AllegroNetlistConversionMessageType || (exports.AllegroNetlistConversionMessageType = AllegroNetlistConversionMessageType = {}));
//# sourceMappingURL=AllegroTypes.js.map